import { ReactNode } from 'react';

export const isNullOrEmpty = (string: string | ReactNode) => {
	return string == '' || string == null || string == undefined;
};
